import { inject, Injectable } from '@angular/core';
import { filter, map, shareReplay } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root',
})
export class UrlUtilsService {
	private router = inject(Router);

	private displayMode$ = this.router.events.pipe(
		filter((event): event is NavigationEnd => event instanceof NavigationEnd),
		map(() => {
			const path = this.router.url.split('?')[0];
			return /(^|\/)displaymode(\/|$)/i.test(path);
		}),
		shareReplay(1)
	);

	isDisplayModeActive = toSignal(this.displayMode$, { initialValue: false });
}
